import { useId, type FC, type ReactNode } from 'react';

export const IdConsumer: FC<{ children: (htmlId: string) => ReactNode }> = ({ children }) => (
    <>{children(useId())}</>
);
